module.exports = __webpack_public_path__ + "media/page-6.c10ce13d.mp3";